import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { ArrowRight, Users, Calendar } from 'lucide-react';

export function CTASection({ onOpenContact }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section 
      id="contact" 
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="cta-section"
    >
      {/* Background */}
      <div className="absolute inset-0 cta-gradient" />
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-line-2 to-transparent" />
      
      <div ref={ref} className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center max-w-3xl mx-auto"
        >
          <p className="eyebrow section-eyebrow-line mb-6 mx-auto justify-center">
            Ready to Build
          </p>
          
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-stark mb-6 tracking-tight">
            Ready to Build the{' '}
            <span className="text-gradient">Future With Us?</span>
          </h2>
          
          <p className="text-lg md:text-xl text-stark-2 mb-12 max-w-2xl mx-auto leading-relaxed">
            Whether you're a business looking to scale with AI or an individual 
            ready to unlock new opportunities — ServeNetics is your partner in transformation.
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-wrap justify-center gap-3 mb-16">
            <motion.button
              whileHover={{ y: -1 }}
              whileTap={{ y: 0 }}
              onClick={onOpenContact}
              className="btn-stark group"
              data-testid="cta-start-journey-btn"
            >
              <span className="availability-dot" />
              Start Your Journey
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </motion.button>
            
            <motion.button
              whileHover={{ y: -1 }}
              whileTap={{ y: 0 }}
              onClick={onOpenContact}
              className="btn-outline"
              data-testid="cta-book-consultation-btn"
            >
              <Calendar className="w-4 h-4" />
              Book a Consultation
            </motion.button>
            
            <motion.button
              whileHover={{ y: -1 }}
              whileTap={{ y: 0 }}
              onClick={onOpenContact}
              className="btn-outline"
              data-testid="cta-join-community-btn"
            >
              <Users className="w-4 h-4" />
              Join Our Community
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default CTASection;
